


import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useOutletContext } from "react-router-dom";
import Kapil_Technologies_logo from "../../../Assets/Navbar/KCS TECH.png";
import Services from "./Services";
import Industries from "./Industries";
import Insights from "./Insights";
import { servicesLinks, industriesLinks } from "../../../utils/navbarLinks";

export const DropdownIcon = ({ isOpen }) =>
  isOpen ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 15.75l7.5-7.5 7.5 7.5"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );

const Navbar = ({ linkClicked }) => {
  const MenuIcon = ({ open }) =>
    open ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.5 6h9.75M10.5 6a1.5 1.5 0 10-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 10-3 0m3 0a1.5 1.5 0 10-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 10-3 0m3 0a1.5 1.5 0 10-3 0m-9.75 0h9.75"
        />
      </svg>
    );

  // Updated insights links with only remaining elements
  const insightsLinks = {
    insights_1: {
      links: {
        subLink1: [
          { name: "Leadership", link: "/insights/leadership" },
          { name: "Customer Stories", link: "/insights/customerstories" },
          { name: "Blog", link: "/insights/blog" },
        ],
      },
    },
  };

  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const [smallScreenActive, setSmallScreenActive] = useState("");
  const [smallScreenSubactive, setSmallScreenSubActive] = useState("");

  const servicesPopupRef = useRef(null);
  const servicesPopupArrowRef = useRef(null);
  const industriesPopupRef = useRef(null);
  const industriesPopupArrowRef = useRef(null);
  const insightsPopupRef = useRef(null);
  const insightsPopupArrowRef = useRef(null);

  const ActiveRef = useRef(active);
  useEffect(() => {
    ActiveRef.current = active;
  }, [active]);

  const handleClickOutside = (event) => {
    if (ActiveRef.current === "services") {
      if (
        servicesPopupRef.current &&
        !servicesPopupRef.current.contains(event.target) &&
        !servicesPopupArrowRef.current.contains(event.target)
      ) {
        setActive("");
      }
    } else if (ActiveRef.current === "industries") {
      if (
        industriesPopupRef.current &&
        !industriesPopupRef.current.contains(event.target) &&
        !industriesPopupArrowRef.current.contains(event.target)
      ) {
        setActive("");
      }
    } else if (ActiveRef.current === "insights") {
      if (
        insightsPopupRef.current &&
        !insightsPopupRef.current.contains(event.target) &&
        !insightsPopupArrowRef.current.contains(event.target)
      ) {
        setActive("");
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <style jsx>{`
        .nav-link {
          position: relative;
          transition: color 0.3s ease;
        }
        
        .nav-link::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background-color: #ef4444;
          transition: width 0.3s ease;
        }
        
        .nav-link:hover::after,
        .nav-link.active::after {
          width: 100%;
        }
        
        .nav-link:hover {
          color: #ef4444;
        }
        
        .dropdown-link {
          position: relative;
          transition: color 0.3s ease;
        }
        
        .dropdown-link::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background-color: #ef4444;
          transition: width 0.3s ease;
        }
        
        .dropdown-link:hover::after,
        .dropdown-link.active::after {
          width: 100%;
        }
        
        .dropdown-link:hover {
          color: #ef4444;
        }
      `}</style>
      
      <nav className="bg-[#fff] shadow-lg xl:sticky xl:top-0 xl:z-50 border-4 border-l-white border-t-white border-r-white border-b-white">
        <div className="relative w-full h-1 bg-gradient-to-r from-red-500 to-red-600">
          <div className="absolute right-0 w-6 h-8 bg-red-500 transform skew-x-12"></div>
        </div>

        <div className="flex items-center font-medium justify-between xl:h-16 lg:px-10">
          <div className="z-50 p-3 xl:w-auto w-full flex justify-between">
            <Link to="/">
              <img
                src={Kapil_Technologies_logo}
                alt="Kapil_Technologies_logo"
                className="xl:cursor-pointer h-16 py-1"
                onClick={() => {
                  linkClicked();
                }}
              />
            </Link>

            <div className="xl:hidden" onClick={() => setOpen(!open)}>
              <MenuIcon open={open} />
            </div>
          </div>

          {/* Navigation links for large screen */}
          <ul className="xl:flex hidden items-center gap-6 relative">
            <li className="text-black font-bold">
              <NavLink
                to="/"
                className="xl:py-1 py-3 px-3 inline-block nav-link"
                onClick={() => {
                  setActive("");
                  linkClicked();
                }}
              >
                Home
              </NavLink>
            </li>

            <li ref={servicesPopupArrowRef} className="text-black font-bold">
              <span
                className={`xl:py-1 py-3 px-3 dropdown-link ${
                  active === "services" ? "active" : ""
                } xl:flex items-center gap-1 hidden cursor-pointer  `}
                onClick={() => {
                  setActive(active !== "services" ? "services" : "");
                }}
              >
                Services
                <DropdownIcon isOpen={active === "services"} />
              </span>
            </li>

            <li ref={industriesPopupArrowRef} className="text-black font-bold">
              <span
                className={`xl:py-1 py-3 px-3 dropdown-link ${
                  active === "industries" ? "active" : ""
                } xl:flex items-center gap-1 hidden cursor-pointer`}
                onClick={() => {
                  setActive(active !== "industries" ? "industries" : "");
                }}
              >
                Industries
                <DropdownIcon isOpen={active === "industries"} />
              </span>
            </li>

            {/* About Us as direct nav element */}
            <li className="text-black font-bold">
              <NavLink
                to="/insights/aboutus"
                className="xl:py-1 py-3 px-3 inline-block nav-link"
                onClick={() => {
                  setActive("");
                  linkClicked();
                }}
              >
                About Us
              </NavLink>
            </li>

            {/* Webinar as direct nav element */}
            <li className="text-black font-bold">
              <NavLink
                to="/insights/webinar"
                className="xl:py-1 py-3 px-3 inline-block nav-link"
                onClick={() => {
                  setActive("");
                  linkClicked();
                }}
              >
                Webinar
              </NavLink>
            </li>

            {/* Insights dropdown with remaining elements */}
            {/* <li ref={insightsPopupArrowRef}>
              <span
                className={`xl:py-1 py-3 px-3 dropdown-link ${
                  active === "insights" ? "active" : ""
                } xl:flex items-center gap-1 hidden cursor-pointer`}
                onClick={() => setActive(active !== "insights" ? "insights" : "")}
              >
                Insights
                <DropdownIcon isOpen={active === "insights"} />
              </span>
              {active === "insights" && (
                <div ref={insightsPopupRef}>
                  <Insights 
                    insightsLinks={insightsLinks} 
                    setActive={setActive} 
                    linkClicked={linkClicked} 
                  />
                </div>
              )}
            </li> */}

            <li className="text-black font-bold">
              <NavLink
                to="/career"
                className="xl:py-1 py-3 px-3 inline-block nav-link"
                onClick={() => {
                  setActive("");
                  linkClicked();
                }}
              >
                Career
              </NavLink>
            </li>

            <li className="text-black font-bold">
              <NavLink
                to="/contact"
                className="xl:py-1 py-3 px-3 inline-block nav-link"
                onClick={() => {
                  setActive("");
                  linkClicked();
                }}
              >
                Contact
              </NavLink>
            </li>
          </ul>

          {/* Mobile screen navigation */}
          <ul
            className={`xl:hidden bg-[#fff] absolute w-full h-auto top-0 py-20 pl-4 z-40 duration-500 ${
              open ? "left-0" : "left-[-100%]"
            }`}
          >
            <li onClick={() => setOpen(false)} className="text-black font-bold">
              <Link to="/" className="py-3 px-3 inline-block text-base">
                Home
              </Link>
            </li>

            <li className="text-black font-bold">
              <span
                className="py-3 px-3 text-base xl:hidden flex justify-between items-center text-black font-bold"
                onClick={() => {
                  setSmallScreenActive(
                    smallScreenActive !== "services" ? "services" : ""
                  );
                  setSmallScreenSubActive("");
                }}
              >
                Services
                <DropdownIcon isOpen={smallScreenActive === "services"} />
              </span>
              <div className="xl:hidden block">
                {smallScreenActive === "services" && (
                  <Services
                    servicesLinks={servicesLinks}
                    smallScreenSubactive={smallScreenSubactive}
                    setSmallScreenSubActive={setSmallScreenSubActive}
                    setSmallScreenActive={setSmallScreenActive}
                    setOpen={setOpen}
                  />
                )}
              </div>
            </li>

            <li className="text-black font-bold">
              <span
                className="py-3 px-3 text-base xl:hidden flex justify-between items-center text-black font-bold"
                onClick={() => {
                  setSmallScreenActive(
                    smallScreenActive !== "industries" ? "industries" : ""
                  );
                  setSmallScreenSubActive("");
                }}
              >
                Industries
                <DropdownIcon isOpen={smallScreenActive === "industries"} />
              </span>
              <div className="xl:hidden block">
                {smallScreenActive === "industries" && (
                  <Industries
                    industriesLinks={industriesLinks}
                    smallScreenActive={smallScreenActive}
                    setSmallScreenSubActive={setSmallScreenSubActive}
                    setSmallScreenActive={setSmallScreenActive}
                    setOpen={setOpen}
                    linkClicked={linkClicked}
                  />
                )}
              </div>
            </li>

            {/* Mobile: About Us as direct link */}
            <li onClick={() => setOpen(false)} className="text-black font-bold">
              <Link to="/insights/aboutus" className="py-3 px-3 inline-block text-base">
                About Us
              </Link>
            </li>

            {/* Mobile: Webinar as direct link */}
            <li onClick={() => setOpen(false)} className="text-black font-bold">
              <Link to="/insights/webinar" className="py-3 px-3 inline-block text-base">
                Webinar
              </Link>
            </li>

            {/* Mobile: Insights dropdown with remaining elements */}
            {/* <li>
              <span
                className="py-3 px-3 text-base xl:hidden flex justify-between items-center"
                onClick={() => {
                  setSmallScreenActive(
                    smallScreenActive !== "insights" ? "insights" : ""
                  );
                }}
              >
                Insights
                <DropdownIcon isOpen={smallScreenActive === "insights"} />
              </span>
              <div className="xl:hidden block">
                {smallScreenActive === "insights" && (
                  <Insights
                    insightsLinks={insightsLinks}
                    smallScreenActive={smallScreenActive}
                    setActive={setActive}
                    setSmallScreenSubActive={setSmallScreenSubActive}
                    setSmallScreenActive={setSmallScreenActive}
                    setOpen={setOpen}
                  />
                )}
              </div>
            </li> */}

            <li onClick={() => setOpen(false)} className="text-black font-bold"> 
              <Link to="/career" className="py-3 px-3 inline-block text-base">
                Career
              </Link>
            </li>

            <li onClick={() => setOpen(false)} className="text-black font-bold">
              <Link to="/contact" className="py-3 px-3 inline-block text-base">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Desktop dropdown menus */}
        {active === "services" && (
          <div className="relative xl:block hidden" ref={servicesPopupRef} >
            <Services
              servicesLinks={servicesLinks}
              active={active}
              setActive={setActive}
              setSmallScreenActive={setSmallScreenActive}
              setOpen={setOpen}
              linkClicked={linkClicked}
            />
          </div>
        )}

        {active === "industries" && (
          <div className="relative xl:block hidden" ref={industriesPopupRef}>
            <Industries
              industriesLinks={industriesLinks}
              active={active}
              setActive={setActive}
              setSmallScreenActive={setSmallScreenActive}
              setOpen={setOpen}
              linkClicked={linkClicked}
            />
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;